var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: {
          size: _vm.size,
          dialog: _vm.dialog,
          withBgClickEvent: false,
          contentClass: _vm.contentClass,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-between w-full pb-4",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center space-x-8 ml-1" },
                      [
                        _c("h2", { staticClass: "text-lg font-medium" }, [
                          _vm._v(_vm._s(_vm.currentTabTitle)),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-gray-400 hover:text-gray-600 transition-colors focus:outline-none",
                        on: { click: _vm.closeModalDialog },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "w-5 h-5",
                            attrs: {
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "flex relative" },
                  [
                    _c("div", {
                      staticClass: "absolute bottom-0 left-0 right-0 border-b",
                    }),
                    _vm._l(_vm.availableTabs, function (tab, index) {
                      return _c(
                        "button",
                        {
                          key: index,
                          class: [
                            "px-6 py-3 transition-colors relative tabs-style focus:outline-none",
                            _vm.currentTab === index
                              ? "tab-color border-b-2 border-color -mb-[2px]"
                              : "text-gray-500 hover:text-gray-700",
                          ],
                          on: {
                            click: function ($event) {
                              _vm.currentTab = index
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tab.title) + " ")]
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("ValidationObserver", {
                  ref: "observer",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ invalid, handleSubmit }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "h-full" },
                            [
                              _vm.currentTab === 0
                                ? _c("CreateClientTab", {
                                    attrs: {
                                      invalid: invalid,
                                      formData: _vm.formData,
                                      isDrafted: _vm.initialData.drafted,
                                    },
                                    on: {
                                      "update:formData":
                                        _vm.handleFormDataUpdate,
                                      edit: _vm.clientEdit,
                                      "save-draft": function ($event) {
                                        return _vm.handleSaveDraft(true, 0)
                                      },
                                      submit: function ($event) {
                                        handleSubmit(() =>
                                          _vm.onSubmit(false, 0)
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.currentTab === 1
                                ? _c("ClientProfileTab", {
                                    ref: "profileTab",
                                    attrs: {
                                      invalid: invalid,
                                      formData: _vm.formData,
                                      isDrafted: _vm.initialData.drafted,
                                      initialStep: _vm.currentEditTab.step,
                                    },
                                    on: {
                                      "update:formData":
                                        _vm.handleFormDataUpdate,
                                      "save-draft": function ($event) {
                                        return _vm.handleSaveDraft(true, 1)
                                      },
                                      submit: function ($event) {
                                        handleSubmit(() =>
                                          _vm.onSubmit(false, 1)
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.currentTab === 2
                                ? _c("CarePlanTab", {
                                    attrs: {
                                      invalid: invalid,
                                      formData: _vm.formData,
                                      isDrafted: _vm.initialData.drafted,
                                      currentUser: _vm.currentUser,
                                      companyId: _vm.companyId,
                                      initialStep: _vm.currentEditTab.step,
                                      clientId: _vm.createdClientId,
                                    },
                                    on: {
                                      "update:formData":
                                        _vm.handleFormDataUpdate,
                                      "save-draft": function ($event) {
                                        return _vm.handleSaveDraft(true, 2)
                                      },
                                      submit: function ($event) {
                                        handleSubmit(() =>
                                          _vm.onSubmit(false, 2)
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.currentTab === 3
                                ? _c("SmartMatchTab", {
                                    attrs: {
                                      invalid: invalid,
                                      formData: _vm.formData,
                                      isDrafted: _vm.initialData.drafted,
                                      companyId: _vm.companyId,
                                      currentUser: _vm.currentUser,
                                      currentUserId: _vm.currentUser.id,
                                    },
                                    on: {
                                      openConfigModal:
                                        _vm.handleOpenConfigModal,
                                      openResultsModal:
                                        _vm.handleOpenResultsModal,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.showSmartMatchConfigModal
        ? _c("SmartMatchConfigModal", {
            staticStyle: { "z-index": "10000" },
            attrs: {
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
            },
            on: { close: _vm.handleCloseConfigModal },
          })
        : _vm._e(),
      _vm.showSmartMatchResultsModal
        ? _c("SmartMatchResultsModal", {
            staticStyle: { "z-index": "10001" },
            attrs: {
              companyId: _vm.companyId,
              projectId: _vm.createdClientId || _vm.initialData?.id,
              managerId: _vm.currentUser.manager?.id || null,
              adminId: _vm.currentUser.admin?.id || null,
              isNewClient: !_vm.isEdit,
            },
            on: { close: _vm.handleCloseResultsModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }